module.exports = __webpack_public_path__ + "static/media/t_cur_04.182d329e.png";